'use es6';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsEnrolledInGettingStarted } from '../actions/GettingStartedActions';

const useIsEnrolledInUserGuide = () => {
  const dispatch = useDispatch();
  const isEnrolled = useSelector(state => state.gettingStarted.isEnrolledInGettingStarted);
  const isEnrolledRequesting = useSelector(state => state.gettingStarted.isGetIsEnrolledRequesting);
  const isEnrolledFetchedOnce = useSelector(state => state.gettingStarted.hasFetchedOnce);
  useEffect(() => {
    if (!isEnrolledFetchedOnce && !isEnrolledRequesting) {
      dispatch(getIsEnrolledInGettingStarted());
    }
  }, [dispatch, isEnrolledFetchedOnce, isEnrolledRequesting]);
  return [isEnrolled, isEnrolledRequesting];
};

export default useIsEnrolledInUserGuide;